import { TAO_KOE } from './../libs';

let promise = null;
const getAffinities = () => {
	return promise = promise ?? new Promise( ( resolve, reject ) => {
		const DY = window.DY;
		DY.API( 'callback', () => {
			DY.ServerUtil.getUserAffinities( ( err, res ) => {
				if ( err ) {
					reject( err );
				} else {
					resolve( res );
				}
			} );
		} );
	} );
};

const initDyAffinitySort = ( scopeEl = document ) => {
	const containerEls = scopeEl.querySelectorAll( '[data-dy-sort="affinity"]' );
	containerEls.forEach( async( containerEl ) => {
		const affinities = await getAffinities();
		const sortItemEls = Array.from( containerEl.querySelectorAll( '[data-dy-affinity-type]' ) ).filter( ( affinityEl ) => containerEl === affinityEl.closest( '[data-dy-sort]' ) );
		sortItemEls.forEach( ( sortItemEl ) => {
			const [ type, value ] = [ sortItemEl.dataset.dyAffinityType, sortItemEl.dataset.dyAffinityValue ];
			sortItemEl.dataset.dyAffinityScore = ( affinities && affinities[ type ] && affinities[ type ][ value ] ) ?? 0;
		} );

		// Sort by Affinity Score.
		const sortedItemEls = sortItemEls.toSorted( ( sortItemElA, sortItemElB ) => {
			return ( parseFloat( sortItemElB.dataset.dyAffinityScore ) * 100 ) - ( parseFloat( sortItemElA.dataset.dyAffinityScore ) * 100 );
		} );

		// Re-Attach the elements at the front.
		sortedItemEls.toReversed().forEach( ( sortItemEl ) => {
			sortItemEl.parentElement.insertAdjacentElement( 'afterbegin', sortItemEl );
		} );

		// Toggle trigger first navItem.
		const firstSortItemEl = sortedItemEls.find( () => true );
		if ( firstSortItemEl && firstSortItemEl.classList.contains( 'mdl_tabbedcontent__nav-item' ) && ! firstSortItemEl.classList.contains( 'is-active' ) ) {
			firstSortItemEl.dispatchEvent( new CustomEvent( 'select-tab.sl' ) );
		}
	} );
};

// Init.
TAO_KOE.ready( 'dy-affinity-sort.js', () => initDyAffinitySort() );
document.addEventListener( 'load_submenu.koe', ( ev ) => {
	const containerEl = ( ev.detail && ev.detail.subMenu ) || ev.target.KOE_MENU_ITEM.getSubmenuElement();
	initDyAffinitySort( containerEl );
} );

// Export.
export {
	getAffinities,
	initDyAffinitySort,
};
